import { render, staticRenderFns } from "./BtnAtualizarAlerta.vue?vue&type=template&id=5f323d87&"
import script from "./BtnAtualizarAlerta.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports